import type { EventName } from "@lit/react";
import { SideNav as SideNavElement, type SideNavEventMap as _SideNavEventMap, } from "@vaadin/side-nav/vaadin-side-nav.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { SideNavElement, };
export type SideNavEventMap = Readonly<{
    onCollapsedChanged: EventName<_SideNavEventMap["collapsed-changed"]>;
}>;
const events = { onCollapsedChanged: "collapsed-changed" } as SideNavEventMap;
export type SideNavProps = WebComponentProps<SideNavElement, SideNavEventMap>;
export const SideNav = createComponent({
    elementClass: SideNavElement, events, react: React, tagName: "vaadin-side-nav"
});
